import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const passwordApi = createApi({
  reducerPath: 'passwordApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/users' }),
  endpoints: (builder) => ({
    generatePasswordResetLink: builder.mutation({
      query: (body) => ({
        url: '/password',
        method: 'POST',
        body
      })
    }),
    resetPassword: builder.mutation({
      query: (body) => ({
        url: '/password',
        method: 'PUT',
        body
      })
    })
  })
})

export const {
  useGeneratePasswordResetLinkMutation,
  useResetPasswordMutation
} = passwordApi

export { passwordApi }
